"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginDefinition_1 = require("auto-widget-framework/src/Plugin/PluginDefinition");
class FormExtensionPluginDefinition extends PluginDefinition_1.default {
    /**
     * @inheritDoc
     */
    static getType() {
        return "form_extension";
    }
}
exports.default = FormExtensionPluginDefinition;
